'use strict';

var _classCallCheck = require("/codebuild/output/src773985007/src/validafy/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src773985007/src/validafy/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/codebuild/output/src773985007/src/validafy/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/codebuild/output/src773985007/src/validafy/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/codebuild/output/src773985007/src/validafy/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var TransformStream = require('readable-stream').Transform;

var pingMessageConverter = require('./ping-message-converter');

var PingMessageStream = /*#__PURE__*/function (_TransformStream) {
  _inherits(PingMessageStream, _TransformStream);

  function PingMessageStream(options) {
    _classCallCheck(this, PingMessageStream);

    var opts = Object.assign(options || {}, {
      objectMode: true
    });
    return _possibleConstructorReturn(this, _getPrototypeOf(PingMessageStream).call(this, opts));
  }

  _createClass(PingMessageStream, [{
    key: "_transform",
    value: function _transform(obj, enc, callback) {
      try {
        var msg = pingMessageConverter(obj);
        this.push(msg);

        if (!msg.success) {
          throw new Error(msg.text);
        }
      } catch (err) {
        return callback(err);
      }

      callback();
    }
  }]);

  return PingMessageStream;
}(TransformStream);

module.exports = PingMessageStream;